import React from 'react';
import Form from '../../components/pages/VPSHostingRequest/Form/Form';
import Continuity from '../../components/pages/VPSHosting/Continuity/Continuity';

const VPSHostingRequest = () => {
  return (
    <div>
      <Form />
      <Continuity />
    </div>
  );
};

export default VPSHostingRequest;
